import React from 'react'
import reportStyles from './PDFReportStyles';    
import { Text, Page, View, Image} from '@react-pdf/renderer'

const VaccinationSupplementPage = (params) => {
   
  const entity = params.entity;
  const reportParams = params.params;  

  return (

<Page size="A4" style={reportStyles.page}>
    <View style={reportStyles.HeaderContainer}>
        <Image src={process.env.PUBLIC_URL + '/images/VaccineHeader2.jpg'}  style={reportStyles.headerImage}/>                                                 
        <Text style={reportStyles.PageTitle}>Vaccination Overview - Part 2</Text>                    
    </View>                            
    <View style={reportStyles.CenterContainerStart}>    
        <View style={reportStyles.table}>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageSubTitle}>Vaccines</Text>
                </View>
                <View style={reportStyles.cell60NB}>
                    <Text style={reportStyles.PageSubTitle}>Recommended Doses</Text>
                </View>
            </View>                               
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>Flu Vaccine</Text>
                    <Text style={reportStyles.descriptionSmall}>Given at 6,7 M and Every Year</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/RedRadioBtnSQ.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>Hepatitis A</Text>
                    <Text style={reportStyles.descriptionSmall}>Given at 12, 18-24 M</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtnSQ.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>Varicella (Chicken Pox)</Text>
                    <Text style={reportStyles.descriptionSmall}>Given at 15, 18-24M</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>Typhoid TCV</Text>
                    <Text style={reportStyles.descriptionSmall}>Given at 6-9 M</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>Tdap (Boosterix)</Text>
                    <Text style={reportStyles.descriptionSmall}>Given at 10 Y</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>HPV for Girl Child</Text>
                    <Text style={reportStyles.descriptionSmall}>Given at 9-14 Y, Follow up dose in1M
after 1st Dose. Additional dose if 1st
dose missed before 14 Y</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreyRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreyRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Text style={reportStyles.descriptionSmall}>Spl Case</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/GreyRadioBtnSQ.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40}>
                    <Text style={reportStyles.PageTextSmall}>Need For Consultation</Text>
                </View>
                <View style={reportStyles.cell20}>
                    <Image src={process.env.PUBLIC_URL + '/images/OrangeCheck.png'} style={reportStyles.image33Cell}/> 
                </View>
                <View style={reportStyles.cell40}>
                    <Text style={reportStyles.PageTextSmall}>Recommended*</Text>
                </View>
            </View>
        </View>                                   
    </View>                            
    <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>*We recommend a paediatrician consultation for vaccination in case of any red or orange dots on
your child's report.
        </Text>
    </View>                            
    </Page>  

  )          
}
  
export default VaccinationSupplementPage